<template>
  <section>
    <div>
      <h3 v-if="isUpdateMode">Update appointment</h3>
      <h3 v-else>Create a new appointment</h3>
      <md-progress-bar
        md-mode="query"
        v-if="savingInProgress"
      ></md-progress-bar>

      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field>
            <label>Client name</label>
            <md-input v-model="clientName" ref="clientNameInput"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field>
            <label>Client telephone number</label>
            <md-input v-model="telephone"></md-input>
          </md-field>
        </div>
      </div>
      <md-field>
        <label>Client email address (optional)</label>
        <md-input v-model="email"></md-input>
      </md-field>

      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field>
            <label for="treatments">Treatment</label>
            <md-select name="treatments" v-model="selectedTreatmentItem">
              <md-optgroup
                :label="item.cat"
                :key="index1"
                v-for="(item, index1) in menuData"
              >
                <md-option
                  :value="index1 + ':' + index2"
                  :key="t.name"
                  v-for="(t, index2) in item.items"
                >
                  {{ t.name }}
                  <small>{{ t.price }}</small>
                </md-option>
              </md-optgroup>
            </md-select>
            <span class="md-helper-text">{{
              selectedTreatment != null ? selectedTreatment.price : ""
            }}</span>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-datepicker v-model="selectedDate" md-immediately>
            <label>Appointment date</label>
          </md-datepicker>
        </div>
      </div>
      <app-time-slot
        @click="onTimeSlotClick"
        :cols="8"
        ref="timeSlots"
      ></app-time-slot>
      <md-switch v-model="isConfirmed">
        <small v-if="isConfirmed"> Appointment is confirmed </small>
        <small v-if="!isConfirmed"> Appointment is not confirmed </small>
      </md-switch>
      <md-tooltip
        md-direction="bottom"
        v-if="isValidAppointment && !isUpdateMode"
        >Please click "Add Appointment" button to submit your form.</md-tooltip
      >
      <md-tooltip
        md-direction="bottom"
        v-if="isValidAppointment && isUpdateMode"
        >Please click "Update Appointment" button to submit your
        form.</md-tooltip
      >
    </div>
  </section>
</template>

<script>
import { eventBus } from "../../eventbus.js";
import TimeSlot from "../../Shared/TimeSlot";
import firebase from "../../../../firebaseConfig";
const db = firebase.firestore();

export default {
  name: "NewAppointment",
  props: {
    details: Object,
  },
  data: function () {
    return {
      appointmentId: null,
      isCreated: false,
      selectedTreatmentItem: null,
      email: null,
      telephone: null,
      clientName: null,
      selectedDate: null,
      selectedTime: null,
      startedAt: new Date(),
      savingInProgress: false,
      isConfirmed: true,
    };
  },
  components: {
    appTimeSlot: TimeSlot,
  },
  computed: {
    isUpdateMode() {
      return (
        (this.details != null && this.details.id != null) ||
        this.$route.params.id
      );
    },
    isCreateMode() {
      return !this.isUpdateMode;
    },
    selectedTreatment() {
      var t = null;
      if (this.selectedTreatmentItem != null) {
        var indexes = this.selectedTreatmentItem.split(":");

        if (this.menuData.length && indexes.length == 2) {
          t = this.menuData[parseInt(indexes[0])].items[parseInt(indexes[1])];
        }
      }
      return t;
    },
    isValidAppointment() {
      var isValid = false;
      if (
        this.selectedTreatmentItem != null &&
        this.selectedDate != null &&
        this.selectedTime != null
      ) {
        isValid = true;
      }
      eventBus.addAppointmentFormValidation(isValid);
      return isValid;
    },
  },
  methods: {
    onTimeSlotClick: function (time) {
      this.selectedTime = time;
      this.selectDateTime();
    },
    selectDateTime: function () {
      if (this.selectedDate && this.selectedTime) {
        var t = this.selectedTime.split(":");
        this.selectedDate.setHours(t[0], t[1]);
        eventBus.selectedDateTime(this.selectedDate, this.selectedTime);
      }
    },

    getAppointmentDataToSave: function (customer, menuId) {
      return {
        client: this.clientName,
        email: this.email,
        tel: this.telephone,
        date: this.selectedDate,
        time: this.selectedTime,
        treatment: this.selectedTreatment,
        creationStarted: this.startedAt,
        creationEnded: new Date(),
        customerId: customer,
        menuId: menuId,
        isConfirmed: this.isConfirmed,
      };
    },
    addOrUpdateAppointment: async function (isDeleted) {
      var self = this;
      this.savingInProgress = true;
      console.log("isDeleted", isDeleted);
      await firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is part of business.
          let customer = idTokenResult.claims.customer;
          if (customer) {
            let menuId = idTokenResult.claims.menu;
            var docRef = null;
            if (self.isUpdateMode) {
              if (isDeleted) {
                if (self.appointmentId == null) {
                  self.appointmentId = self.$route.path.id;
                }

                docRef = db
                  .collection("appointments")
                  .doc(self.appointmentId)
                  .delete();
                console.log("delete", self.appointmentId);
              } else
                docRef = db
                  .collection("appointments")
                  .doc(self.appointmentId)
                  .set(self.getAppointmentDataToSave(customer, menuId));
            } else
              docRef = db
                .collection("appointments")
                .add(self.getAppointmentDataToSave(customer, menuId));

            console.log("docRef", docRef);
            docRef
              .then((data) => {
                console.log("Document successfully written!", data);
                if (data?.id) self.appointmentId = data.id;
                self.savingInProgress = false;
                if (self.isUpdateMode)
                  eventBus.appointmentUpdated(self.appointmentId);
                else eventBus.newAppointmentCreated(self.appointmentId);
              })
              .catch((error) => {
                self.savingInProgress = false;
                console.error("Error writing document: ", error);
              });
          }
        });

      return self.appointmentId;
    },
    addOrUpdateAppointmentClickListener: function (isDeleted) {
      this.addOrUpdateAppointment(isDeleted);
    },
    loadAppointment: async function (id) {
      const appointment = (
        await db.collection("appointments").doc(id).get()
      ).data();

      if (appointment == null) {
        console.log("Could not load appointment with id:", id);
      } else {
        this.email = appointment.email;
        this.clientName = appointment.client;
        this.telephone = appointment.tel;
        this.selectedDate = new Date(appointment.date.seconds * 1000);
        this.isConfirmed = appointment.isConfirmed;
        this.$refs.timeSlots.selectTime(appointment.time);
      }
    },
  },
  created: function () {
    if (this.details && this.details.id) {
      {
        this.appointmentId = this.details?.id;
        this.loadAppointment(this.appointmentId);
      }
    } else if (this.$route.params.id) {
      this.appointmentId = this.$route.params.id;
      this.loadAppointment(this.appointmentId);
    }

    if (this.isCreateMode) {
      // reset input fields

      console.log("created event. Is create mode");
    }

    eventBus.$on(
      ["add-appointment-click", "update-appointment-click"],
      this.addOrUpdateAppointmentClickListener
    );
  },
  beforeDestroy: function () {
    eventBus.$off(
      "add-appointment-click",
      this.addOrUpdateAppointmentClickListener
    );
    eventBus.$off(
      "update-appointment-click",
      this.addOrUpdateAppointmentClickListener
    );
  },
};
</script>

<style lang="scss" scoped>
.md-switch {
  display: flex;
}
</style>